import type { APIActurisCustomerDetailData } from 'types/api.types';

export interface CustomerValidationError {
  field: string;
  label: string;
}

export interface CustomerValidationResult {
  isValid: boolean;
  errors: CustomerValidationError[];
}

export const validateCustomerForQuoting = (
  customer: APIActurisCustomerDetailData | undefined,
): CustomerValidationResult => {
  if (!customer) {
    return {
      isValid: false,
      errors: [{ field: 'customer', label: 'Customer data not loaded' }],
    };
  }

  const errors: CustomerValidationError[] = [];

  if (!customer.first_name?.trim()) {
    errors.push({ field: 'first_name', label: 'First Name' });
  }

  if (!customer.last_name?.trim()) {
    errors.push({ field: 'last_name', label: 'Last Name' });
  }

  if (!customer.date_of_birth) {
    errors.push({ field: 'date_of_birth', label: 'Date of Birth' });
  }

  if (!customer.street_address?.trim()) {
    errors.push({ field: 'street_address', label: 'Street Address' });
  }

  if (!customer.city?.trim()) {
    errors.push({ field: 'city', label: 'City' });
  }

  if (!customer.province) {
    errors.push({ field: 'province', label: 'Province' });
  }

  if (!customer.postal_code?.trim()) {
    errors.push({ field: 'postal_code', label: 'Postal Code' });
  }

  const hasPhone = customer.home_phone?.trim() || customer.mobile_phone?.trim();
  if (!hasPhone) {
    errors.push({ field: 'phone', label: 'Phone (Home or Mobile)' });
  }

  if (!customer.email?.trim()) {
    errors.push({ field: 'email', label: 'Email' });
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

export const getMissingFieldsSet = (
  customer: APIActurisCustomerDetailData | undefined,
): Set<string> => {
  const result = validateCustomerForQuoting(customer);
  return new Set(result.errors.map((e) => e.field));
};
